import getLoginStatus from '@pro/common/utils/getLoginStatus.js';
import clearLocalLoginState from '@pro/common/utils/clearLocalLoginState';
import * as regionConfig from '@pro/common/consts/region-config';
import getURLByIndex from '@pro/common/utils/getURLByIndex';
import { COUNTRY_OR_REGION_LIST, COUNTRY_OR_REGION_MAP } from '@pro/common/consts/country-or-region';
import request from '@/natives/libs/request';
import getRoute from '@pro/common/utils/getRoute';
import isPublicPage from '@pro/common/utils/isPublicPage';
import isSupport from '@pro/common/utils/isSupport';
import logoutOnehikid from '@pro/common/utils/logoutOnehikid';
import Cookie from 'js-cookie';

/**
 * 取出search和hash中的参数，以字符串的方式重新组装成hash
 */
function getURLQuery() {
  let flag = false;
  let tempSearch = '';
  let tempHash = '';
  if (window.location.search) {
    flag = true;
    tempSearch = window.location.search.substring(1);
  }
  if (window.location.hash.indexOf('?') >= 0) {
    flag = true;
    tempHash = window.location.hash.substring(window.location.hash.indexOf('?') + 1);
  }
  if (flag) {
    return `#?${ tempSearch }${tempSearch ? '&' : '' }${tempHash}`;
  }
  return '';
}

async function loadContent() {
  await import('./main');
}

// 判断是否是登录后需要自动跳转的链接
function isAutoJumpPage() {
  // 跨大区的自动跳转链接设置在前置完成，此处跳过
  if (window.location.href.includes('mainJumpUrl=')) {
    return false;
  }
  const path = window.location.hash.slice(1);
  const arr = [
    '/installer',
    '/MicroApp/about',
    '/Explore',
    '/Solution',
    '/Project',
    '/Order',
    '/Incentive',
    '/Support',
    '/Product',
    '/MyAccount'
  ];
  for (const item of arr) {
    if (path.startsWith(item)) {
      return true;
    }
  }
  return false;
}

function getCookie(name: string) {
  const match = document.cookie.match(new RegExp(`(^| )${ name }=([^;]+)`));
  if (match) {
    return match[2];
  }
  return "";
}


async function check() {
  // 判断当前为非登录状态
  if (!(getCookie('hik_connect_pro_userlogin') && localStorage.getItem('hik_connect_pro_data'))) {
    // 未登录，但是打开的页面是登录后的页面。记录一下链接，登录后恢复到这个页面
    if (isAutoJumpPage()) {
      sessionStorage.removeItem('jump-after-login');//解决js报错Setting the value of 'jump-after-login' exceeded the quota
      sessionStorage.setItem('jump-after-login', window.location.href);
    }
    const autoLoginCookie = getCookie('portalAutoLoginId');
    // 存在自动登录cookie
    if (autoLoginCookie
        && (!window.location.href.includes('?hpcAfterLogin=true')
            && !window.location.href.includes('?hpcAutoLogin=true')
            && !window.location.href.includes('ticketJump')
            && !window.location.href.includes('authorizationCode')
            && !window.location.href.includes('thirdJump')
            && !window.location.href.includes('invitedRegisterAfter')
            && !window.location.href.includes('invitedRegister')
            && !window.location.href.includes('check'))) {
      //cookie校验接口
      const authorizeRes = await request.post('/hpp/ccfauth/public/authorize', {
        productId: 1,
        businessId: 0,
        clientSource: process.env.clientSource
      }, {hasErrorHandle: false}).catch(() => null);
      if (authorizeRes?.[0]?.loginType === 1 || authorizeRes?.[0]?.loginType === 2) {
        if (authorizeRes?.[0]?.loginType === 2) { // hpc 自动登录
          localStorage.setItem('autoLoginTicket', authorizeRes[0].authTicket);
          window.location.href = `${window.location.origin }?hpcAutoLogin=true`;
          //   &autoLoginInfo=${JSON.stringify(authorizeRes[0])}
          //   const autologinRes = await request.post('/hpp/company/security/v3/account/login', {authTicket: authorizeRes[0].authTicket, loginType: authorizeRes[0].loginType, loginClient: 2}).catch(() => null);
          //   if (autologinRes[0]) {
          //     sessionStorage.setItem('notLogUserInfo', JSON.stringify(autologinRes[0]));
          //     window.location.href = window.location.origin + '?hpcAfterLogin=true';
          //   }
          return;
        } else if (authorizeRes?.[0]?.loginType === 1) { // SSO 自动登录
          window.location.href = `${window.location.origin }/?ticket=${authorizeRes[0]?.authTicket}&autoLogin=true#/ticketJump/login`;
          return;
        }
      } else if ((window.location.href.includes('authorizationCode')
                  || window.location.href.includes('invitedRegisterAfter')
                  || window.location.href.includes('invitedRegister'))) {
        // 部分情况下，删除上次的自动登录标记
        Cookie.remove('portalId');
        Cookie.remove('portalAutoLoginId');
      }
    }
  }
  const route = getRoute();
  const queryHash = getURLQuery();

  if (isSupport()) {
    return true;
  }
  // 如果是主域名打开，直接从`localstorage`里面读取国家或区域进行跳转
  if ([regionConfig.REGION_HREF.MAIN, regionConfig.REGION_HREF.WWW_MAIN].includes(window.location.origin)) {
    const storageIndexStr = localStorage.getItem('hik_connect_pro_country');
    let storageIndexNum = storageIndexStr ? Number(storageIndexStr) : -1;
    storageIndexNum = Number.isNaN(storageIndexNum) ? -1 : storageIndexNum;

    const url = getURLByIndex(storageIndexNum);
    if (storageIndexNum > -1 && url) {
      // 增加v标志，避免访问的是目标大区的缓存页面
      let resultUrl = `${url}?v=${Date.now()}&type=jump&country=${storageIndexNum}`;
      if (isAutoJumpPage()) {
        resultUrl += `&mainJumpUrl=${encodeURIComponent(window.location.href)}`;
      }
      window.location.href = resultUrl;
      return false;
    }
    // 缓存没有索引则ip定位
    const resp = await request.get('/hpp/company/support/v1/ip/country').catch(() => null);
    const countryCodeString = resp?.[2]?.data?.areaInfo?.countryCode;
    if (countryCodeString) {
      const countryCodeNumber = Number(countryCodeString);
      let index = -1;
      if (Number.isNaN(countryCodeNumber)) {
        index = COUNTRY_OR_REGION_LIST().find((item) => item.countryCode === countryCodeString)?.index ?? -1;
      } else {
        index = COUNTRY_OR_REGION_MAP[countryCodeNumber] ? countryCodeNumber : -1;
      }

      const url = getURLByIndex(index);
      if (index > -1 && url) {
        // 增加v标志，避免访问的是目标大区的缓存页面
        let resultUrl = `${url}?v=${Date.now()}&type=jump&country=${index}`;
        if (isAutoJumpPage()) {
          resultUrl += `&mainJumpUrl=${encodeURIComponent(window.location.href)}`;
        }
        window.location.href = resultUrl;
        return false;
      }
    }
  }

  // 如果链接是邀请员工链接，不管已登录还是未登录都跳到落地页
  if (window.location.href.includes('/invitedRegister?')) {
    // 部分情况下，删除上次的自动登录标记
    Cookie.remove('portalId');
    Cookie.remove('portalAutoLoginId');
    clearLocalLoginState();
    logoutOnehikid(`${window.location.origin }/lp/index.html${ window.indexHash }${queryHash}`);
    return false;
  }

  if (queryHash.includes('ticket=') && queryHash.includes('service=')) {
    // SSO跨区跳转
    return true;
  } else if (route.query.fromOldApps || route.query.hpcAfterLogin || route.query.hpcAutoLogin) {
    // 登录中
    return true;
  } else if (route.path === '/' && !getLoginStatus()) {
    window.location.href = `/lp/index.html${ window.indexHash }${queryHash}`;
    return false;
  } else if (!isPublicPage() && !getLoginStatus()) {
    window.location.href = `/lp/index.html${ window.indexHash }${queryHash}`;
    return false;
  }
  return true;
}

(async function () {
  const result = await check();

  if (result) {
    await loadContent();
    try {
      const serverKey = localStorage.getItem('need-change-server-key');
      if (serverKey) {
        return;
      }
      const [data] = await request.post('/hpp/ccfdic/v1/nologin/dicset/get', { dicSetKey: Number(process.env.clientSource) === 0 ? ["HPC.dicSet.noCdnPath.BASE_LINE", "HPC.dicSet.cdnPath.BASE_LINE", "HPC.dicSet.apiDomain.BASE_LINE"] : ["HPC.dicSet.noCdnPath.LTS_CONNECT", "HPC.dicSet.noCdnPath.LTS_CONNECT", "HPC.dicSet.apiDomain.LTS_CONNECT"]}, {hasErrorHandle: false});
      if (data) {
        localStorage.setItem('need-change-server-key', JSON.stringify(data));
      } else {
        localStorage.removeItem('need-change-server-key');
      }
    } catch (error) {
      localStorage.removeItem('need-change-server-key');
    }
  }
})();
